import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Mid-Section-Pc.scss";

//components
import RoomDetailsCard from "../../OverView/Pc-and-Large-Screens/Room-Details-Card";

//icons
import { IoMdAdd } from "react-icons/io";
import { CiSearch } from "react-icons/ci";
import SelectedProperty from "./SelectedProperty";
import { MdOutlineRoom } from "react-icons/md";
import { MdOutlineBedroomParent } from "react-icons/md";
import { IoPersonSharp } from "react-icons/io5";
import { MdOutlineWaterDrop } from "react-icons/md";
import { CiTrash } from "react-icons/ci";
import CreatePropertyModal from "./CreatePropertyModal";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import {
  getAllProperties,
  getAllHouses,
} from "../../../../redux/slices/sliceActions";
import EditPropertyModal from "./EditProperty";
import AddRolesModal from "./AddRoles";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const MidSectionProperties = () => {
  // redux methods
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { propertyId } = useParams();

  // data fetched from the store
  const { properties } = useSelector((state) => state.landlordslice);

  const [isSqueezed, setIsSqueezed] = useState(false);

  // edit property
  const [showEditPropertyModal, setShowEditPropertyModal] = useState(false);
  const [propertyToEdit, setPropertyToEdit] = useState("");

  // add roles
  const [showAddRolesModal, setShowAddRolesModal] = useState(false);

  // modal to create property
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // selected property
  const [selectedProperty, setSelectedProperty] = useState(null);

  useEffect(() => {
    dispatch(getAllProperties());
  }, [dispatch]);

  useEffect(() => {
    if (!propertyId) {
      return;
    }

    const matchedProperty = properties.find(
      (property) => property._id === propertyId,
    );

    if (!matchedProperty) {
      return;
    }

    setSelectedProperty(matchedProperty);
    setIsSqueezed(true);
  }, [propertyId, properties]);

  useEffect(() => {
    const housePropertyId = propertyId || selectedProperty?._id;

    if (!housePropertyId) {
      return;
    }

    console.log("the selected property", housePropertyId);
    dispatch(getAllHouses({ id: housePropertyId })).then((res) => {
      console.log("get all houses response", res);
    });
  }, [dispatch, propertyId, selectedProperty?._id]);

  const propertyCards = properties.map((property, index) => (
    <RoomDetailsCard
      key={index + 1}
      name={property.name}
      isSqueezed={isSqueezed}
      setIsSqueezed={setIsSqueezed}
      propertyDetails={property}
      setSelectedProperty={setSelectedProperty}
    />
  ));

  const filteredProperties = propertyCards.filter((property) =>
    property.props.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <>
      {propertyId ? (
        <>
          <SelectedProperty
            propertyId={propertyId}
            propertyName={selectedProperty?.name || "Property"}
          />
        </>
      ) : (
        <div className="mid-section-pc-admin">
          <div className="title-and-search">
            <div className="title-container">
              <div className="greeting">Properties </div>
              <div className="title">Property Management and Roles</div>
            </div>

            <div
              className="actions-button"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <IoMdAdd />

              <div>Add Property</div>
            </div>
          </div>
          <hr className="horizontal-line" />
          <div className="search-container">
            <div className="search-bar">
              <div className="search-icon">
                <CiSearch />
              </div>
              <input
                type="text"
                placeholder="Search Properties"
                value={searchTerm}
                className="search-input"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="property-list-and-individual-detail">
            <div
              className="properties-list-container"
              style={
                isSqueezed
                  ? { width: "30%", flexDirection: "column" }
                  : { width: "94%" }
              }
            >
              {filteredProperties.length > 0 ? null : (
                <div className="no-properties">No Properties Found</div>
              )}
              {filteredProperties.map((property) => property)}
            </div>

            <div
              className="individual-property-details"
              style={isSqueezed ? {} : { display: "none" }}
            >
              <div className="property-images">
                <div
                  className="property-image-1"
                  style={{
                    backgroundImage: `url(${selectedProperty?.images?.[0]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                ></div>
                <div className="side-images">
                  <div
                    className="property-image-2"
                    style={{
                      backgroundImage: `url(${selectedProperty?.images?.[1]})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                  <div
                    className="property-image-3"
                    style={{
                      backgroundImage: `url(${selectedProperty?.images?.[2]})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                </div>
              </div>
              <div className="title-and-location">
                <div className="left-column">
                  <div className="title">{selectedProperty?.name}</div>
                  <div className="location">
                    <MdOutlineRoom /> <div>{selectedProperty?.location}</div>
                  </div>
                </div>

                {/* Added: show assigned C2B account number with tooltip (system assigned, unchangeable) */}
                <div
                  className="property-account-number"
                  title="This C2B account number is assigned by the system and cannot be changed."
                >
                  <div className="label">C2B Account</div>
                  <div className="value">
                    {selectedProperty?.propertyAccountNumber ?? "—"}
                  </div>
                </div>
              </div>
              <div className="details">
                <div className="overview">Overview</div>
                <div className="description">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Quisquam qui animi tempore saepe nam quaerat dolor unde
                  placeat nisi? Quia dicta ad eius voluptatibus excepturi.
                </div>
                <div className="icons-container">
                  {" "}
                  <div className="icon-description">
                    <MdOutlineBedroomParent />{" "}
                    <div> {selectedProperty?.houses?.length} Rooms</div>
                  </div>
                  <div className="icon-description">
                    <IoPersonSharp />{" "}
                    <div>{selectedProperty?.occupiedHouses} Tenants</div>
                  </div>
                  <div className="icon-description">
                    <MdOutlineWaterDrop />{" "}
                    <div> {selectedProperty?.water_charge} ksh Per unit</div>
                  </div>
                  <div className="icon-description">
                    <CiTrash />{" "}
                    <div>{selectedProperty?.garbage_charge} ksh </div>
                  </div>
                </div>
              </div>
              <div className="role-takers-container">
                <div className="title">Role Takers</div>
                <div className="images">
                  <div className="place-holders">
                    {selectedProperty?.role_takers?.map((roleTaker) => {
                      return (
                        <div className="image-place-holder">
                          <div className="icon"></div>
                          <div className="name">
                            {roleTaker?.role?.charAt(0).toUpperCase() +
                              roleTaker?.role.slice(1)}
                          </div>
                        </div>
                      );
                    })}

                    <div
                      className="add-roles"
                      onClick={() => setShowAddRolesModal(true)}
                    >
                      <div className="icon">
                        {" "}
                        <IoMdAdd fontSize={25} />
                      </div>
                      <div className="name">Add</div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: vw(10),
                  justifyContent: "start",
                }}
              >
                <div className="view-more">
                  <button
                    className="view-more-button"
                    onClick={() => {
                      setPropertyToEdit(selectedProperty);
                      setShowEditPropertyModal(true);
                    }}
                  >
                    Edit Property
                  </button>
                </div>
                <div className="view-more">
                  <button
                    className="view-more-button"
                    onClick={() => {
                      if (!selectedProperty?._id) {
                        return;
                      }

                      navigate(
                        `/auth/landlord/properties/${selectedProperty._id}/houses`,
                      );
                    }}
                  >
                    View Houses
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showModal && (
            <>
              <CreatePropertyModal setShowModal={setShowModal} />
            </>
          )}
          {showEditPropertyModal && (
            <>
              <EditPropertyModal
                setShowModal={setShowEditPropertyModal}
                propertyToEdit={propertyToEdit}
              />
            </>
          )}
          {showAddRolesModal && (
            <>
              <AddRolesModal
                setShowModal={setShowAddRolesModal}
                propertyToEdit={selectedProperty}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default MidSectionProperties;
